import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

import { AuthProvider } from '@/lib/auth/auth-context';
import { ThemeProvider } from '@/lib/theme/theme-context';

import { AuthGate } from './AuthGate';
import { createQueryClient } from './query-client';

export function AppProviders() {
  // Lazy initialiser: a QueryClient built during render would be discarded and
  // rebuilt on every render, losing the cache each time.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      {/* Outside AuthProvider: the sign-in screen is themed too. */}
      <ThemeProvider>
        <AuthProvider>
          <AuthGate />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
